import type { EntryPoint, EntryPointComponent } from 'react-relay';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import type { JsmGsConfigProviderEntrypointProps } from './JsmGsConfigProvider.entrypoint.types.tsx';

type SlaConfigProviderEntrypointComponent = EntryPointComponent<
	{},
	{},
	JsmGsConfigProviderEntrypointProps,
	{} | null
>;

export const slaGsConfigProviderEntrypoint: EntryPoint<SlaConfigProviderEntrypointComponent, {}> =
	createEntryPoint({
		root: JSResourceForInteraction<SlaConfigProviderEntrypointComponent>(
			/* webpackChunkName: "ai-rovo-actions-jsm-gs-sla-provider" */ './SlaConfigProviderEntry.tsx',
		),
		getPreloadProps: () => ({}),
	});
